(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collections-navigation"] && !Shopify.designMode) return;
  try {
    (function() {
    const sections = document.querySelectorAll('.section-resource-list');
    sections.forEach(section => {
      const navigation = section.querySelector('.collections-navigation');
      if (!navigation) return;
      
      const radios = navigation.querySelectorAll('input[type="radio"]');
      const tabs = section.querySelectorAll('.collection-tab');
      
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const collectionIndex = radio.dataset.collectionIndex;
          
          tabs.forEach(tab => {
            const isActive = tab.dataset.collectionIndex === collectionIndex;
            tab.classList.toggle('is-active', isActive);
          });
        });
      });
      
      // Set initial active state
      const checkedRadio = navigation.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        const initialIndex = checkedRadio.dataset.collectionIndex;
        tabs.forEach(tab => {
          tab.classList.toggle('is-active', tab.dataset.collectionIndex === initialIndex);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linked-products"] && !Shopify.designMode) return;
  try {
    class LinkedProducts extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('[data-linked-products-list]');
      this.indicators = {
        fadeLeft: this.querySelector('.linked-products__fade-edge--left'),
        fadeRight: this.querySelector('.linked-products__fade-edge--right'),
        arrowLeft: this.querySelector('.linked-products__scroll-arrow--left'),
        arrowRight: this.querySelector('.linked-products__scroll-arrow--right')
      };

      if (!this.list) return;

      this.scrollTimeout = null;
      this.resizeObserver = null;
      this.cachedScrollDistance = null;
      
      this.init();
    }

    init() {
      this.scrollToActiveItem();
      this.setupEventListeners();
      this.updateScrollIndicators();
    }

    setupEventListeners() {
      // Use passive listeners for better scroll performance
      this.list.addEventListener('scroll', () => this.handleScroll(), { passive: true });
      
      // Use ResizeObserver instead of resize event for better performance
      this.resizeObserver = new ResizeObserver(() => {
        this.cachedScrollDistance = null;
        this.updateScrollIndicators();
      });
      this.resizeObserver.observe(this.list);

      // Setup arrow buttons with event delegation would be overkill here, direct binding is fine
      this.indicators.arrowLeft?.addEventListener('click', () => this.scrollByOneItem(-1));
      this.indicators.arrowRight?.addEventListener('click', () => this.scrollByOneItem(1));
    }

    handleScroll() {
      // Debounce scroll updates for performance
      if (this.scrollTimeout) return;
      
      this.scrollTimeout = requestAnimationFrame(() => {
        this.updateScrollIndicators();
        this.scrollTimeout = null;
      });
    }

    scrollByOneItem(direction) {
      if (!this.cachedScrollDistance) {
        const firstItem = this.list.querySelector('[data-linked-product-item]');
        if (!firstItem) return;
        
        const itemWidth = firstItem.offsetWidth;
        const gap = parseFloat(getComputedStyle(this.list).gap) || 0;
        this.cachedScrollDistance = itemWidth + gap;
      }

      this.list.scrollBy({
        left: this.cachedScrollDistance * direction,
        behavior: 'smooth'
      });
    }

    scrollToActiveItem() {
      const activeItem = this.querySelector('[data-active]');
      if (!activeItem) return;

      requestAnimationFrame(() => {
        const { scrollLeft, clientWidth } = this.list;
        const { offsetLeft, offsetWidth } = activeItem;
        
        const targetScroll = offsetLeft - (clientWidth - offsetWidth) / 2;

        this.list.scrollTo({
          left: Math.max(0, targetScroll),
          behavior: 'smooth'
        });
      });
    }

    updateScrollIndicators() {
      const { scrollLeft, scrollWidth, clientWidth } = this.list;
      const maxScroll = scrollWidth - clientWidth;
      
      const isAtStart = scrollLeft <= 10;
      const isAtEnd = scrollLeft >= maxScroll - 10;

      // Batch DOM updates
      requestAnimationFrame(() => {
        this.indicators.fadeLeft?.classList.toggle('hidden', isAtStart);
        this.indicators.arrowLeft?.classList.toggle('hidden', isAtStart);
        this.indicators.fadeRight?.classList.toggle('hidden', isAtEnd);
        this.indicators.arrowRight?.classList.toggle('hidden', isAtEnd);
      });
    }

    disconnectedCallback() {
      // Clean up observers when element is removed
      this.resizeObserver?.disconnect();
      if (this.scrollTimeout) {
        cancelAnimationFrame(this.scrollTimeout);
      }
    }
  }

  customElements.define('linked-products', LinkedProducts);
  } catch(e) { console.error(e); }
})();

})();
